<template>
  <div v-loading.body="loading">
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>筛选查询</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-col :span="24">
                <el-form :inline="true" :model="form" class="demo-form-inline">
                  <el-form-item>
                    <el-select
                      v-model="form.origin"
                      placeholder="仓库"
                      style="width: 150px"
                    >
                      <el-option :value="0" label="全部"></el-option>
                      <el-option
                        v-for="item in storehouseIds"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="search_type"
                      placeholder="波次号"
                      style="width: 150px"
                    >
                      <el-option
                        v-for="item in search_options"
                        :key="item.key"
                        :label="item.name"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item style="margin-left: -15px; width: 165px">
                    <el-input
                      v-model="search_value"
                      placeholder="请输入搜索内容"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.handle_status"
                      placeholder="工单状态"
                      style="width: 150px"
                    >
                      <el-option value="">全部</el-option>
                      <el-option
                        v-for="item in handle_status"
                        :key="item.key"
                        :label="item.value"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.shipping_company"
                      placeholder="快递公司"
                      style="width: 150px"
                    >
                      <el-option value="">全部</el-option>
                      <el-option
                        v-for="item in conditionData.shipping_company"
                        :key="item"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item>
                    <el-select
                      v-model="form.is_exception"
                      placeholder="拆包状态"
                      style="width: 150px"
                    >
                      <el-option value="">全部</el-option>
                      <el-option
                        v-for="item in cb_status"
                        :key="item.key"
                        :label="item.value"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="提交时间：" style="width: 500px">
                    <el-date-picker
                      v-model="form.create_time"
                      type="datetimerange"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      :default-time="['06:00:00', '06:00:00']"
                    >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="拆包时间：" style="width: 500px">
                    <el-date-picker
                      v-model="form.back_time"
                      type="datetimerange"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      :default-time="['06:00:00', '06:00:00']"
                    >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="success" @click="search">查询</el-button>
                  </el-form-item>
                </el-form>
              </el-col>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row v-if="!loading">
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表：</div>
          <el-button
            style="margin-left: auto"
            type="primary"
            size="mini"
            @click="output"
            >导出</el-button
          >
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column
              prop="id"
              label="工单id"
              width="120"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="goods_img"
              label="商品图片"
              width="120"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    display: inline-block;
                  "
                >
                  <img
                    v-for="(item, index) in scope.row.imgs"
                    :key="index"
                    :src="item"
                    style="width: 100%; height: 100%"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="goods_name"
              label="商品名称"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="goods_no"
              label="货号"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              label="颜色/尺码/件数"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.co_val }}/{{ scope.row.si_val }}/{{
                  scope.row.goods_number
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="goods_lib_origin"
              label="发货地"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="service_order_handle_status"
              label="工单状态"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="shipping_num"
              label="快递单号"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="shipping_company"
              label="快递公司"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="user_id"
              label="用户id"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="consignee"
              label="收件人姓名"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="out_time"
              label="出库日期"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="update_time"
              label="拒签登记时间"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cb_status"
              label="拆包状态"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="admin_name"
              label="拆包人"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="back_time"
              label="拆包时间"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="dbids"
              label="打标id"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="dbid_note"
              label="打标备注"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="out_shipping_time"
              label="日志"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <el-button type="text" @click="showLogList(scope.row.id)">
                  查看</el-button
                >
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.goods_number != scope.row.c_num"
                  type="primary"
                  size="mini"
                  @click="handleDetail(scope.row.id)"
                >
                  拆包
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper ,sizes"
            :total="resData.count"
            :page-size="form.pagesize"
            :page-sizes="[50, 100, 200, 500, 1000]"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <!--拆包-->
    <div v-if="isShow">
      <un-package
        :work_id="work_id"
        @onCloseDialog="onCloseDialog"
      ></un-package>
    </div>
    <!--查看日志-->
    <div v-if="showLog">
      <work-log :work_id="work_id" @onCloseDialog="onCloseDialog"></work-log>
    </div>
  </div>
</template>
<style>
.el-table .stock-row {
  background: #f7fd7b;
}
</style>
<script>
import apiBaseURL from "@/utils/baseUrl.js";

import WorkLog from "../work/components/WorkLog.vue";
import UnPackage from "../work/components/UnPackage.vue";

export default {
  components: {
    UnPackage,
    WorkLog,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchCondition();
    });
  },
  data() {
    return {
      resData: [],
      conditionData: {
        shipping_company: [],
      },
      cityData: {},
      districtData: {},
      is_show_search_option: 0,
      search_type: "wave_picking_no",
      search_options: [
        { key: "wave_picking_no", name: "波次号" },
        { key: "shipping_num", name: "快递单号" },
        { key: "user_id", name: "用户id" },
        { key: "consignee", name: "收件人姓名" },
        { key: "work_id", name: "工单id" },
        { key: "goods_no", name: "货号" },
      ],
      search_value: "",
      form: {
        origin: 0,
        // check_time:this.defaultDate(),
        create_time: this.$excalibur.getDateTimeOnHours(-30, 6),
        multipleSelection: [],
        shipping_company: "",
        status: "",
        pagesize: 100,
      },
      origin_list: [
        {
          origin_id: 1,
          origin_name: "广州",
        },
        {
          origin_id: 2,
          origin_name: "杭州",
        },
      ],
      storehouseIds: [],
      handle_status: [
        {
          key: 7,
          value: "已完成",
        },
        {
          key: 9,
          value: "等候寄回",
        },
      ],
      cb_status: [
        {
          key: 1,
          value: "异常",
        },
        {
          key: 2,
          value: "正常",
        },
      ],
      show_log_time: 0,
      loading: false,
      url: "/erp/cod/denyList",
      origin: 1,
      curPage: 1,
      tableLoading: false,
      filterFold: false,
      wave_num: 0,
      shipping_company: "",
      checkVisible: false,
      mark_type: 0,
      can_sub: 1,
      check_id: 0,
      check_status: 1,
      money_time: "",
      check_reason: "",
      showLog: false,
      work_id: 0,
      isShow: false,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    handleDetail(id) {
      this.isShow = true;
      this.work_id = Number(id);
    },
    onCloseDialog(e) {
      this.isShow = false;
      this.showLog = false;
      this.fetchData();
    },
    showLogList(id) {
      this.work_id = Number(id);
      this.showLog = true;
    },
    handleSizeChange(val) {
      this.form.pagesize = val;
      this.fetchData(true);
    },
    output() {
      this.form.is_excel = 1;
      // this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.loading = false;
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },

    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    onSubmit() {},
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.form).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },

    search() {
      this.form.page = 1;
      this.form.is_excel = 0;
      this.loading = true;
      this.fetchData(true);
    },
    selectOrigin(key) {
      this.form.origin = this.origin = key;
      // this.loading = true;
      // this.$http.post(this.url, this.filteredForm).then(res => {
      //     setTimeout(() => {
      //         this.loading = false;
      //     }, 200);
      //     if (res.data.code !== 200) {
      //         this.$message.error(res.data.msg);
      //         this.resData = res.data.data;
      //     } else {
      //         this.resData = res.data.data;
      //     }
      // });
    },

    fetchCondition() {
      this.$http.post("/erp/cod/condition").then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.conditionData = res.data.data;
          this.form.origin = parseInt(res.data.data.origin);
          console.log(this.form.origin);
        }
      });

      this.$http
        .post("/erp/StockStorehouse/listStockStorehouseConfig")
        .then((res) => {
          if (res.data.code == 200) {
            this.storehouseIds = res.data.data;
          }
        });
    },
    fetchData(showLoading) {
      this.$http
        .post("/erp/StockStorehouse/listStockStorehouseConfig")
        .then((res) => {
          if (res.data.code == 200) {
            this.storehouseIds = res.data.data;
          }
        });
      if (showLoading) {
        this.loading = true;
      }
      if (this.search_value != "") {
        for (const key in this.search_options) {
          this.form[this.search_options[key].key] = "";
        }
        this.form[this.search_type] = this.search_value;
      } else {
        for (const key in this.search_options) {
          this.form[this.search_options[key].key] = "";
        }
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1rpx solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/cod/denyList.vue